<template>
  <ul class="oh-timeline" role="list">
    <li v-for="(it, i) in normalized" :key="i" class="oh-item">
      <div class="oh-when">
        <div class="oh-date">{{ it.dateOnly }} {{ it.timeOnly }}</div>
      </div>

      <div class="oh-rail">
        <span
          class="oh-dot"
          :class="{'oh-dot--filled': it.type === 'current', 'oh-dot--checked': it.type === 'past'}"
          :aria-label="it.type"
          role="img"
        >
          <svg v-if="it.status === 'completed'" class="oh-check" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>

      </div>

      <div class="oh-body">
        <div class="oh-title">
          <span class="oh-title-main">{{ it.title }}</span>
          <span v-if="it.by" class="oh-by">{{ it.by }}</span>
        </div>
        <div v-if="it.note" class="oh-note">
          {{ it.note }}
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "OrderHistory",
  props: {
    items: { type: Array, required: true },
    locale: { type: String, default: "en-GB" },
    timeZone: { type: String, default: "UTC" },
  },
  computed: {
    normalized() {
      return this.items?.slice()
        .sort((a, b) => new Date(b.at) - new Date(a.at))
        .map((raw) => {
          const d = new Date(raw.at);
          const dateOnly = new Intl.DateTimeFormat(this.locale, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            timeZone: this.timeZone,
          }).format(d);
          const timeOnly = new Intl.DateTimeFormat(this.locale, {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
            timeZone: this.timeZone,
          }).format(d);
          return {
            ...raw,
            dateOnly,
            timeOnly,
          };
        });
    },
  },
};
</script>

<style scoped>
.oh-card {
  border: 1px solid #e1e5ea;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.oh-header {
  padding: 10px 14px;
  font-weight: 600;
  border-bottom: 1px solid #e1e5ea;
}

.oh-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.oh-item {
  display: grid;
  grid-template-columns: 112px 28px 1fr;
  gap: 8px 12px;
  padding: 2px 14px;
  align-items: start;
}

.oh-item:last-child {
  border-bottom: 0;
}

.oh-when {
  color: #555;
  font-size: 12px;
  line-height: 1.2;
}

.oh-date {
  margin-bottom: 2px;
  white-space: nowrap;
  padding-top: 4px;
}

.oh-time {
  color: #777;
  white-space: nowrap;
}

.oh-rail {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.oh-rail::before {
  content: "";
  position: absolute;
  top: -50%;
  bottom: -300%;
  left: 50%;
  width: 2px;
  background: #e6e6e6;
  transform: translateX(-50%);
}

.oh-dot {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #c9c9c9;
  border-radius: 50%;
  background: #fff;
  box-sizing: border-box;
  z-index: 100;
}

.oh-dot--filled {
  background: #2e7d32;
  border-color: #2e7d32;
}

.oh-dot--accent {
  border-color: #3b82f6;
}

.oh-body {
  min-width: 0;
  margin-bottom: 16px;
}

.oh-title {
  font-size: 14px;
  color: #222;
  margin-bottom: 4px;
}

.oh-by {
  font-weight: 600;
  margin-left: 4px;
  color: #111;
}

.oh-note {
  font-size: 12px;
  line-height: 1.4;
}

.oh-dot {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #c9c9c9;
  border-radius: 50%;
  background: #fff;
  box-sizing: border-box;
  z-index: 100;
}

.oh-dot--filled {
  background: #2e7d32;
  border-color: #2e7d32;
  color: #fff;
}

.oh-dot--checked {
  background: #fff;
  border-color: #c9c9c9;
  color: #777777;
}

.oh-check {
  position: absolute;
  width: 14px;
  height: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

@media (max-width: 600px) {
  .oh-item {
    grid-template-columns: 120px 24px 1fr;
  }
}
</style>
